import styled, { css } from 'styled-components'

export const StyledButton = styled.button<{ colorType: 'black' | 'white'; wide?: boolean }>`
	padding: 12px ${({ wide }) => (wide ? '77' : '45')}px;
	background-color: #000000;
	border: none;
	color: #fff;
	height: auto;
	box-shadow: none;
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	cursor: pointer;
	@media only screen and (max-width: 1199px) {
		padding: 12px 23px;
	}
	@media only screen and (max-width: 768px) {
		width: 100%;
		padding: 12px 97px;
		margin-bottom: 16px;
	}
	&:hover {
		background-color: #16a538;
		border-color: #16a538;
	}
	&:disabled {
		background-color: #fff;
		border: 1px solid #dbdbdb;
		box-sizing: border-box;
		border-radius: 2px;
		div {
			color: #999999;
		}
	}
	div {
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #fff;
		@media only screen and (max-width: 1199px) {
			font-size: 12px;
			line-height: 16px;
		}
	}

	${({ colorType }) =>
		colorType === 'white' &&
		css`
			border: 2px solid #fff;
			background: #19bb4f;
		`}
`
export const StyledButtonReset = styled.button`
	box-shadow: none;
	background-color: transparent;
	border-color: transparent;
	cursor: pointer;
`
